import { handleAPIRequest } from "../../../api/api";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const [data, setData] = useState({
    countries: [],
    email1: "",
    email2: "",
    contact1: "",
    contact2: "",
    address1: "",
    address2: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await handleAPIRequest("get", "get-country-names", null);
        setData(response);
      } catch (error) {
        setData({
          countries: [],
          email1: "",
          email2: "",
          contact1: "",
          contact2: "",
          address1: "",
          address2: "",
        });
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="bg-blue-600 text-white text-sm py-10">
      <div className="flex justify-between items-center">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-gray-300">Home</Link></li>
              <li><Link to="/pricing" className="hover:text-gray-300">Pricing</Link></li>
              <li><Link to="/guide" className="hover:text-gray-300">Guide</Link></li>
              <li><Link to="/about-us" className="hover:text-gray-300">About Us</Link></li>
              <li><Link to="/tenders/national" className="hover:text-gray-300">National Tenders</Link></li>
              <li><Link to="/tenders/international" className="hover:text-gray-300">International Tenders</Link></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <p><strong>Emails:</strong> {data.email1 || "N/A"}, {data.email2 || "N/A"}</p>
            <p><strong>National Contact:</strong> {data.contact1 || "N/A"}</p>
            <p><strong>International Contact:</strong> {data.contact2 || "N/A"}</p>
          </div>

          {/* Scrollable Countries List */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Countries</h3>
            <div className="max-h-40 overflow-y-auto border border-gray-300 p-3 rounded-md scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
              {data.countries.length > 0 ? (
                <ul className="space-y-1">
                  {data.countries.map((country, index) => (
                    <li key={index} className="bg-blue-500 text-white px-3 py-1 rounded-md text-sm">
                      {country}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Loading Countries...</p>
              )}
            </div>
          </div>

          {/* Locations */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Locations</h3>
            <div className="flex justify-between space-x-4">
              {data.address1 && (
                <div>
                  <p className="font-semibold mb-2">National Address</p>
                  <iframe
                    title="Address 1"
                    className="w-full h-32 rounded-md"
                    src={`https://www.google.com/maps?q=${encodeURIComponent(data.address1)}&output=embed`}
                    loading="lazy"
                  ></iframe>
                </div>
              )}
              {data.address2 && (
                <div>
                  <p className="font-semibold mb-2">International Address</p>
                  <iframe
                    title="Address 2"
                    className="w-full h-32 rounded-md"
                    src={`https://www.google.com/maps?q=${encodeURIComponent(data.address2)}&output=embed`}
                    loading="lazy"
                  ></iframe>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
      </div>
        <div className="mt-8 border-t border-gray-700 pt-4 text-center">
          <p>&copy; 2024 Bilcono. All rights reserved.</p>
        </div>
    </footer>
  );
};

export default Footer;
